module.exports = __webpack_public_path__ + "static/ziarno_stosik-f2441921ccc0ee2aa953fa6262d30dda.png";